module.exports = __webpack_public_path__ + "static/media/ic.e0f6a604.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ic.jpg
// module id = 5774
// module chunks = 0